import { OTPChannelTypes } from 'features/securities/setting/types';
import { TOtpRecipients } from './types';

export const mapOtpOptions = (otpRecipients: TOtpRecipients) =>
  otpRecipients?.map((o) => {
    if (o.channel === OTPChannelTypes.EMAIL) {
      return {
        value: OTPChannelTypes.EMAIL,
        icon: '/icon/password-email-small.svg',
        text: 'Send via Email',
        subText: o.target,
      };
    }
    if (o.channel === OTPChannelTypes.WHATSAPP) {
      return {
        value: OTPChannelTypes.WHATSAPP,
        icon: '/icon/password-whatsapp.svg',
        text: 'Send via Whatsapp',
        subText: o.target,
      };
    }
    if (o.channel === OTPChannelTypes.SMS) {
      return {
        value: OTPChannelTypes.SMS,
        icon: '/icon/password-message.svg',
        text: 'Send via SMS',
        subText: o.target,
      };
    }
    return {
      value: OTPChannelTypes.EMAIL,
      icon: '/icon/password-email-small.svg',
      text: 'Send via Email',
      subText: o.target,
    };
  });

export const calculateRemainingOtpSecond = (dateTime) => {
  if (!dateTime) {
    return 0;
  }

  const givenTime = new Date(dateTime);
  const currentTime = new Date();
  const timeDifference = givenTime.getTime() - currentTime.getTime();
  const remainingSecond = Math.floor(timeDifference / 1000);

  return remainingSecond;
};
